import { z, ZodSchema } from "zod";
import { useMutation } from "@tanstack/react-query";
import { formatFirebaseError } from "@core/services/api/formatFirebaseError";
import { registerUser } from "../utils/registerUser";
import { authEventBus } from "../auth.events";
import { Invitation, ClaimedVia } from "@core/features/invitation";

type Args = {
  invitation: Invitation;
  claimedVia?: ClaimedVia | null;
  onSuccess?: (data: any) => void;
  schema: ZodSchema;
  onError?: (error: Error) => void;
};

export function useSignupMutation({
  invitation,
  claimedVia,
  onSuccess,
  schema,
  onError,
}: Args) {
  return useMutation({
    mutationFn: async (data: z.infer<typeof schema>) => {
      return await registerUser({
        data,
        inviteCode: invitation?.shortcode,
        claimedVia,
        onError,
      });
    },
    onError: (error: Error) => {
      throw new Error(formatFirebaseError(error.message));
    },
    onSuccess: async (data) => {
      authEventBus.emitEvent("auth:signup:completed", {
        invitation: invitation,
      });

      // submit callback
      await onSuccess?.(data);
    },
  });
}

export default useSignupMutation;
